import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

export function useIntl() {
  const { locale } = useI18n();

  const currency = 'EUR'; // TODO: should change when we supports other currency

  const numberFormat = computed(
    () =>
      (number: number | bigint, opts: Intl.NumberFormatOptions = {}) =>
        new Intl.NumberFormat(locale.value, {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
          ...opts,
        }).format(number),
  );

  const dateTimeFormat = computed(
    () =>
      (date: Date | number, opts: Intl.DateTimeFormatOptions = {}) =>
        new Intl.DateTimeFormat(locale.value, {
          year: 'numeric',
          month: 'short',
          day: 'numeric',
          ...opts,
        }).format(date),
  );

  const currencyFormat = computed(
    () =>
      (
        number: number | bigint,
        { currency: requestedCurrency, ...opts }: Omit<Intl.NumberFormatOptions, 'style'> = {},
      ) =>
        new Intl.NumberFormat(locale.value, {
          style: 'currency',
          // TODO: handle potential currency change here
          currency: requestedCurrency ?? currency,
          currencyDisplay: 'narrowSymbol',
          ...opts,
        }).format(number),
  );

  return {
    dateTimeFormat,
    numberFormat,
    currencyFormat,
  };
}
